import React, { Fragment, memo } from 'react';

import classNames from "core/helpers/common/classNames";

import Icon from "core/ui-kit/icon";

import useDate from "core/hooks/useDate";

const MainButton = ({
    onOpenTimeZonesControl,
    isCollapsed,
    opened,
    date,
}) => {
    const { dateService } = useDate();

    return (
        <div
            className={classNames('rt--sidebar-content-time-zones', opened ? 'opened' : '')}
            onClick={onOpenTimeZonesControl}
        >
            <Icon name="time-zone"/>
            {
                !isCollapsed && (
                    <Fragment>
                        <div className="rt--sidebar-content-time-zones-selected">
                            {`${dateService.format(date)} (UTC${dateService.toString(dateService.getNow(), "Z")})`}
                        </div>
                        <Icon name="right"/>
                    </Fragment>
                )
            }
        </div>
    )
}

export default memo(MainButton);
